var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.36C31.5 23.5479 24.5799 30.22 16 30.22C7.42016 30.22 0.5 23.5479 0.5 15.36C0.5 7.17209 7.42016 0.5 16 0.5C24.5799 0.5 31.5 7.17209 31.5 15.36Z",
    stroke: "#002C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03197 12.9492H10.7376V25.3305H7.03197V12.9492ZM8.86175 6.66675C9.45632 6.66675 10.0265 6.90178 10.447 7.32014C10.8674 7.7385 11.1036 8.30592 11.1036 8.89757C11.1036 9.48922 10.8674 10.0566 10.447 10.475C10.0265 10.8934 9.45632 11.1284 8.86175 11.1284C7.62628 11.1284 6.66602 10.127 6.66602 8.89757C6.66602 7.66818 7.62628 6.66675 8.86175 6.66675ZM12.9341 12.9492H16.5937V14.6796C16.9815 14.1043 17.506 13.633 18.1205 13.3074C18.7351 12.9818 19.4208 12.812 20.1171 12.813H21.1235C23.4568 12.813 25.3327 14.7255 25.3327 17.0015V25.3334H21.6731V24.1951V18.6409C21.6277 17.2295 20.6667 16.1363 19.2483 16.1363C17.8299 16.1363 16.6405 17.2287 16.5944 18.6409V25.3334H12.9348L12.9341 12.9492Z",
    fill: "#002C43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHover);
export default __webpack_public_path__ + "static/media/Linkedin-hover.f52c51da524fc903f5b76a1964ab210c.svg";
export { ForwardRef as ReactComponent };